(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/slide-in-container/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/app/slide-in-container/assets/javascripts/prescript.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.app = svs.app || {};
  svs.app.slide_in_container = svs.app.slide_in_container || {};
  svs.app.slide_in_container.views = svs.app.slide_in_container.views || {};
})(svs);

 })(window);